var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "meta-insights" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "filters" }, [
        _c(
          "div",
          { staticClass: "filter-item" },
          [
            _c("label", [_vm._v("Tarih Aralığı")]),
            _vm._v(" "),
            _c("a-range-picker", {
              attrs: {
                format: _vm.dateFormat,
                placeholder: ["Başlangıç", "Bitiş"],
              },
              on: { change: _vm.onDateChange },
              model: {
                value: _vm.dateRange,
                callback: function ($$v) {
                  _vm.dateRange = $$v
                },
                expression: "dateRange",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "filter-item" },
          [
            _c("label", [_vm._v("Granularity")]),
            _vm._v(" "),
            _c(
              "a-select",
              {
                staticStyle: { width: "150px" },
                on: { change: _vm.onGranularityChange },
                model: {
                  value: _vm.granularity,
                  callback: function ($$v) {
                    _vm.granularity = $$v
                  },
                  expression: "granularity",
                },
              },
              [
                _c("a-select-option", { attrs: { value: "DAY" } }, [
                  _vm._v("Günlük"),
                ]),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "MONTH" } }, [
                  _vm._v("Aylık"),
                ]),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "HALF_HOUR" } }, [
                  _vm._v("Yarım Saat"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "filter-item" },
          [
            _c(
              "a-button",
              {
                attrs: { type: "primary", loading: _vm.loading },
                on: { click: _vm.fetchAllData },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "material-icons",
                    staticStyle: { "font-size": "16px", "margin-right": "4px" },
                  },
                  [_vm._v("refresh")]
                ),
                _vm._v("\n                Yenile\n            "),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "a-tabs",
        {
          on: { change: _vm.onTabChange },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "a-tab-pane",
            { key: "messaging", attrs: { tab: "Messaging Analytics" } },
            [
              _c("MessagingAnalytics", {
                attrs: {
                  channel: _vm.channel,
                  filters: _vm.filters,
                  loading: _vm.loadingStates.messaging,
                  data: _vm.analyticsData.messaging,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            { key: "conversation", attrs: { tab: "Conversation Analytics" } },
            [
              _c("ConversationAnalytics", {
                attrs: {
                  channel: _vm.channel,
                  filters: _vm.filters,
                  loading: _vm.loadingStates.conversation,
                  data: _vm.analyticsData.conversation,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            { key: "pricing", attrs: { tab: "Pricing Analytics" } },
            [
              _c("PricingAnalytics", {
                attrs: {
                  channel: _vm.channel,
                  filters: _vm.filters,
                  loading: _vm.loadingStates.pricing,
                  data: _vm.analyticsData.pricing,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            { key: "template", attrs: { tab: "Template Analytics" } },
            [
              _c("TemplateAnalytics", {
                attrs: {
                  channel: _vm.channel,
                  filters: _vm.filters,
                  loading: _vm.loadingStates.template,
                  data: _vm.analyticsData.template,
                  templates: _vm.templates,
                  selectedTemplateIds: _vm.selectedTemplateIds,
                },
                on: {
                  "update:selectedTemplateIds": _vm.onTemplateIdsChange,
                  fetch: _vm.fetchTemplateAnalytics,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            {
              key: "templateGroup",
              attrs: { tab: "Template Group Analytics" },
            },
            [
              _c("TemplateGroupAnalytics", {
                attrs: {
                  channel: _vm.channel,
                  filters: _vm.filters,
                  loading: _vm.loadingStates.templateGroup,
                  data: _vm.analyticsData.templateGroup,
                  selectedGroupIds: _vm.selectedTemplateGroupIds,
                },
                on: {
                  "update:selectedGroupIds": _vm.onTemplateGroupIdsChange,
                  fetch: _vm.fetchTemplateGroupAnalytics,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Meta Insights")]),
      _vm._v(" "),
      _c("div", { staticClass: "subtitle" }, [
        _vm._v("WhatsApp Business API istatistiklerini görüntüleyin"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }